<template>
  <div>
    <vue-headful title="Credimóvil | FAQ"/>
    <menu-component></menu-component>
    <!-- Banner Area -->
    <section class="banner_area banner_area_2">
    	<div class="container">
    		<h6>Faq</h6>
    		<h2>Preguntas frecuentes</h2>
    		<ol class="breadcrumb">
                <li><a href="/">Inicio</a></li>
                <li><a href="/faq" class="active">Faq</a></li>
            </ol>
    	</div>
    </section>
    <!-- Banner Area -->

    <!-- Faq Area -->
    <section class="faq_area">
        <h2>Preguntas frecuentes</h2>
        <div class="container">
            <div class="faq_accordion">
                <div class="item" id="faqq1">
                    <a href="#" class="collapsed scroll-position1" data-toggle="collapse" data-target="#faq1">¿Quiénes somos?</a>
                    <div id="faq1" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Somos una financiera con más de 25 años de experiencia en préstamos de nómina y automotrices.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq2">
                    <a href="#" class="collapsed scroll-position2" data-toggle="collapse" data-target="#faq2">¿Qué plazos?</a>
                    <div id="faq2" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Manejamos plazos de 12 a 48 meses.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq3">
                    <a href="#" class="collapsed scroll-position3" data-toggle="collapse" data-target="#faq3">¿Qué años modelo son financiables?</a>
                    <div id="faq3" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Para modelos 2009 a modelo actual, es decir 12 años , ¡¡¡esto de todas las marcas!!!</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq4">
                    <a href="#" class="collapsed scroll-position4" data-toggle="collapse" data-target="#faq4">¿Con qué enganche?</a>
                    <div id="faq4" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Desde un 20 por ciento de enganche.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq5">
                    <a href="#" class="collapsed scroll-position5" data-toggle="collapse" data-target="#faq5">¿Qué tasa de interés manejamos?</a>
                    <div id="faq5" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Tasa del 2.32 mensual neto.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq6">
                    <a href="#" class="collapsed scroll-position6" data-toggle="collapse" data-target="#faq6">¿Tienen flexibilidad en Buró?</a>
                    <div id="faq6" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Sí, contamos con mayor flexibilidad que las financieras tradicionales, contamos con esquemas de crédito que nos permiten ofrecer opciones para quienes no son sujetos a créditos tradicionales.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq7">
                    <a href="#" class="collapsed scroll-position7" data-toggle="collapse" data-target="#faq7">No vivo en Guadalajara, ¿puedo ser sujeto de Crédito?</a>
                    <div id="faq7" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Sí, por ser la única financiera con cobertura nacional podemos atenderte en cualquier parte de la república.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq8">
                    <a href="#" class="collapsed scroll-position8" data-toggle="collapse" data-target="#faq8">¿Puedo comprar un vehículo legalizado?</a>
                    <div id="faq8" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Desde un 20 por ciento de enganche.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq9">
                    <a href="#" class="collapsed scroll-position9" data-toggle="collapse" data-target="#faq9">¿Con qué enganche?</a>
                    <div id="faq9" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Sí, si la unidad fue legalmente importada.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq10">
                    <a href="#" class="collapsed scroll-position10" data-toggle="collapse" data-target="#faq10">No compruebo Ingresos y no tengo historial de crédito, ¿soy sujeto a crédito?</a>
                    <div id="faq10" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Sí, somos la única financiera que contamos con un programa específico que permite ofrecer una opción para ti.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq11">
                    <a href="#" class="collapsed scroll-position11" data-toggle="collapse" data-target="#faq11">¿Puedo hacer prepagos en mi crédito?</a>
                    <div id="faq11" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>¿Puedo hacer prepagos en mi crédito?</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq12">
                    <a href="#" class="collapsed scroll-position12" data-toggle="collapse" data-target="#faq12">¿Qué edad debe tener el titular del crédito?</a>
                    <div id="faq12" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>De 21 a 69 años de edad.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq13">
                    <a href="#" class="collapsed scroll-position13" data-toggle="collapse" data-target="#faq13">¿Dónde realizo mis pagos mensuales una vez que contrate el  crédito?</a>
                    <div id="faq13" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Tus pagos los realizas en una cuenta bancaria con un número referenciado y puedes hacer pagos en ventanilla o bien con la comodidad de una transferencia.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq14">
                    <a href="#" class="collapsed scroll-position14" data-toggle="collapse" data-target="#faq14">¿Mi crédito cuenta con seguro para el auto?</a>
                    <div id="faq14" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Sí, contamos con precios muy competitivos y a partir del segundo año puedes contratarlo por tu cuenta.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq15">
                    <a href="#" class="collapsed scroll-position15" data-toggle="collapse" data-target="#faq15">¿Cuentan con arrendamiento?</a>
                    <div id="faq15" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Sí, podemos ofrecerte un esquema de arrendamiento puro.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq16">
                    <a href="#" class="collapsed scroll-position16" data-toggle="collapse" data-target="#faq16">¿A dónde puedo dirigirme para recibir atención personalizada?</a>
                    <div id="faq16" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Puedes contactarnos y pedir atención personalizada en nuestro número 01 800 2630474 y con gusto uno de nuestros asesores te atenderá para brindarte toda la información necesaria.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq17">
                    <a href="#" class="collapsed scroll-position17" data-toggle="collapse" data-target="#faq17">¿Dónde puedo ubicar la unidad que deseo adquirir?</a>
                    <div id="faq17" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Si ya tienes ubicada la unidad que deseas, contáctanos y nosotros seremos el enlace entre quien vende la unidad y tú, así mismo sino has visto una unidad podemos ayudarte a localizar una con nuestro asociados comerciales, solo contáctanos.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq18">
                    <a href="#" class="collapsed scroll-position18" data-toggle="collapse" data-target="#faq18">La unidad que yo quiero la tiene un particular, ¿puedo comprarla a crédito?</a>
                    <div id="faq18" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Sí, podemos ofrecerte crédito para venta entre particulares.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq19">
                    <a href="#" class="collapsed scroll-position19" data-toggle="collapse" data-target="#faq19">¿Cuánto tengo que demostrar de ingresos para aplicar al crédito?</a>
                    <div id="faq19" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>Con nosotros se te pide una comprobación de 2 a 1 generalmente, es importante mencionar que contamos con planes que se adaptan a tus necesidades.</p>
                       </div>
                    </div>
                </div>
                <div class="item" id="faqq20">
                    <a href="#" class="collapsed scroll-position20" data-toggle="collapse" data-target="#faq20">¿Es necesario contar con aval y/o Obligado solidario para contratar un crédito?</a>
                    <div id="faq20" class="collapse" data-parent=".faq_accordion">
                       <div class="accordion_content">
                            <p>No necesariamente, la mayoría de nuestras operaciones no lo requiere.</p>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Faq Area -->

    <!-- Get started -->
    <section class="get_started_area">
      <div class="container">
        <h2>¿Preparado para comenzar?</h2>
        <p>Inicia tu trámite a través de nuestra plataforma</p>
        <a href="/pre-approval" class="theme_btn">Aplicar </a>
      </div>
    </section>
      <!-- End get started -->
  </div>
</template>

<script>
    export default {
        name: 'Faq',
        mounted: function() {
            $("#bottom").on("click", function() {
                console.log('Entro');
                var position = $("#faq5").offset().top;
                $('html, body').animate({
                scrollTop: position
                }, 2000);
            });
        },
        created() {
            $(".scroll-position").on("click", function() {
                console.log('Entro2');
                var position = $("#faq5").offset().top;
                $('html, body').animate({
                scrollTop: position
                }, 1000);
            });
        },
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Faq.vue